module.exports = "/_next/static/images/TheCustomerDataPlatformReport2021-b825b3dd943f9f5be3f512602eb69985.png";